import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Report: AppRouteRecordRaw = {
  path: '/develop',
  name: 'Develop',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '研发管理',
    requiresAuth: true,
    icon: 'icon-book',
    order: 1,
  },
  children: [
    {
      path: 'goods-plan',
      name: 'GoodsPlan',
      component: () => import('@/views/develop/goodsPlan/index.vue'),
      meta: {
        title: '商品企划',
        requiresAuth: true,
        ignoreCache: true,
        roles: ['*'],
      },
    },
    {
      path: 'add-plan',
      name: 'AddPlan',
      component: async () => {
        const cpn = await import('@/views/develop/goodsPlan/addPlan.vue');
        return { ...cpn.default, name: 'AddPlan' };
      },
      props: (route: any) => ({
        id: route.query.id,
        copy: route.query.copy,
      }),
      meta: {
        title: '新增商品企划',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['goodsPlanEdit'],
      },
    },
    {
      path: 'edit-plan',
      name: 'EditPlan',
      component: async () => {
        const cpn = await import('@/views/develop/goodsPlan/addPlan.vue');
        return { ...cpn.default, name: 'EditPlan' };
      },
      props: (route: any) => ({
        id: route.query.id,
        copy: route.query.copy,
      }),
      meta: {
        title: '编辑商品企划',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['goodsPlanGet'],
      },
    },
    {
      path: 'design-style',
      name: 'DesignStyle',
      component: () => import('@/views/develop/designStyle/index.vue'),
      meta: {
        title: '设计款管理',
        requiresAuth: true,
        roles: ['goodsSampleGet'],
      },
    },
    {
      path: 'add-design-style',
      name: 'AddDesignStyle',
      component: async () => {
        const cpn = await import('@/views/goods/add-or-edit.vue');
        return { ...cpn.default, name: 'AddDesignStyle' };
      },
      props: () => ({
        pageType: 'designStyle',
      }),
      meta: {
        title: '新增样衣',
        requiresAuth: true,
        roles: ['goodsSampleEdit'],
        hideInMenu: true,
      },
    },
    {
      path: 'edit-design-style',
      name: 'EditDesignStyle',
      component: async () => {
        const cpn = await import('@/views/goods/add-or-edit.vue');
        return { ...cpn.default, name: 'EditDesignStyle' };
      },
      props: () => ({
        pageType: 'designStyle',
      }),
      meta: {
        title: '编辑样衣',
        requiresAuth: true,
        roles: ['goodsSampleGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'sample-pick',
      name: 'SamplePick',
      component: () => import('@/views/develop/samplePick/index.vue'),
      meta: {
        title: '样衣挑款',
        requiresAuth: true,
        ignoreCache: true,
        roles: ['goodsSampleReview'],
      },
    },
    {
      path: 'sample-demand',
      name: 'SampleDemand',
      component: () => import('@/views/develop/sampleDemand/index.vue'),
      meta: {
        title: '打样需求',
        requiresAuth: true,
        roles: ['makeSampleOrderGet'],
      },
    },
    {
      path: 'add-deliverySample',
      name: 'addDeliverySample',
      component: async () => {
        const cpn = await import(
          '@/views/develop/sampleDemand/add-view-delivery.vue'
        );
        return { ...cpn.default, name: 'addDeliverySample' };
      },
      meta: {
        title: '交付样衣',
        requiresAuth: true,
        hideInMenu: true,
        ignoreCache: true,
        roles: ['*'],
      },
    },
    {
      path: 'view-deliverySample',
      name: 'viewDeliverySample',
      component: async () => {
        const cpn = await import(
          '@/views/develop/sampleDemand/add-view-delivery.vue'
        );
        return { ...cpn.default, name: 'viewDeliverySample' };
      },
      meta: {
        title: '交付记录',
        ignoreCache: true,
        requiresAuth: true,
        hideInMenu: true,
        roles: ['sampleHandoverOrderGet'],
      },
    },
    {
      path: 'add-sample',
      name: 'addSample',
      component: async () => {
        const cpn = await import(
          '@/views/develop/sampleDemand/add-view-sample.vue'
        );
        return { ...cpn.default, name: 'addSample' };
      },
      meta: {
        title: '新增打样',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['makeSampleOrderSubmit'],
      },
    },
    {
      path: 'view-sample',
      name: 'viewSample',
      component: async () => {
        const cpn = await import(
          '@/views/develop/sampleDemand/add-view-sample.vue'
        );
        return { ...cpn.default, name: 'viewSample' };
      },
      meta: {
        title: '查看打样需求',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['makeSampleOrderGet'],
      },
    },
  ],
};

export default Report;
